import { Camp } from '../camp.model';

export function isCamp(resource: unknown): resource is Camp {
  return (
    resource instanceof Camp ||
    (typeof resource === 'object' &&
      resource !== null &&
      (resource as any).sleepover !== undefined &&
      (resource as any).location !== undefined)
  );
}
